import * as OvationsApi from 'core/ovations-api';

import mockCertifiableAddress from './certifiableAddress';
import mockCustomer from './customer';

export const mockRegistrationRequest: OvationsApi.Types.RegistrationRequest = {
    ...mockCustomer,
    address: mockCertifiableAddress,
    password: 'password',
    confirmPassword: 'password',
    confirmEmail: 'test@test.com',
    dealerRegistration: '',
};

// export default mockRegistrationRequest;
